import { createContext, useState } from 'react';
import api from 'services/api';

export const IndicadorQualidadeContext = createContext();

export const IndicadorQualidadeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [indicadorQualidade, setIndicadorQualidade] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getIndicadorQualidade = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: indicadorQualidade?.filter,
        page: indicadorQualidade?.page,
        size: indicadorQualidade?.size,
        order: indicadorQualidade?.order,
        ...payload,
      });
      setIndicadorQualidade((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <IndicadorQualidadeContext.Provider
      value={{
        getLoading,
        indicadorQualidade,
        getIndicadorQualidade,
      }}
    >
      {children}
    </IndicadorQualidadeContext.Provider>
  );
};
